module.exports = __webpack_public_path__ + "static/screen-placement-6e38c2301c4c83665cd69a4c177370bb.png";